export default __webpack_public_path__ + "fonts/ionicons.1fa6a1e8581aaedf73440699627f0166.ttf";